import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-40" data-testid="not-found-page">
      <p className="font-mono text-sm text-[#0B14A0]">404</p>
      <h1 className="font-display text-5xl sm:text-6xl font-bold tracking-tight mt-4">Sidan hittades inte.</h1>
      <Link to="/" className="inline-block mt-8 rounded-full bg-[#0B14A0] text-white px-6 py-3 font-semibold" data-testid="not-found-home-link">Till startsidan</Link>
    </section>
  );
}
